import api from "../config/api";
import { RolePermissionPayload } from "../redux/actions/authUserActions";

export const saveRolePermissions = (data: RolePermissionPayload) =>
  api.post(`/roles/role/?type=permission`, data);

export const getRolePermissions = (roleId: number) =>
  api.get(`/roles/role/?type=permission&roleId=${roleId}`);

export const getRoles = () => api.get(`/roles/role/?type=roles`);
export const updateRolePermissions = (data: RolePermissionPayload) =>
  api.put(`/roles/role/?type=permission`, data);
